import { AnyAction, configureStore, Store } from '@reduxjs/toolkit';
import { combineEpics, createEpicMiddleware, EpicMiddleware } from 'redux-observable';
import { IS_DEV } from '../../../Utils/Constants';
import MediaDeviceMenuEpics from '../Components/MediaDeviceMenu/MediaDeviceMenuEpics';
import { mediaDeviceMenuReducer } from '../Components/MediaDeviceMenu/MediaDeviceMenuReducer';
import SmoLanguageMenuEpics from '../Components/SmoLanguageMenu/SmoLanguageMenuEpics';
import AuthPageEpics from '../Pages/Auth/AuthPageEpics';
import { authPageReducer } from '../Pages/Auth/AuthPageReducer';
import CreateMoonListEpics from '../Pages/CreateMoonList/CreateMoonListEpics';
import { createMoonListReducer } from '../Pages/CreateMoonList/CreateMoonListReducer';
import MoonListEpics from '../Pages/MoonList/MoonListEpics';
import { moonListReducer } from '../Pages/MoonList/MoonListReducer';
import MoonListsEpics from '../Pages/MoonLists/MoonListsEpics';
import { moonListsReducer } from '../Pages/MoonLists/MoonListsReducer';
import WidgetEpics from '../Pages/Widget/WidgetEpics';
import { widgetReducer } from '../Pages/Widget/WidgetReducer';
import WidgetFrontEpics from '../Pages/WidgetFront/WidgetFrontEpics';
import DebugEpics from './Debug/DebugEpics';
import { debugReducer } from './Debug/DebugReducer';
import { serviceStoreReducer } from './Service/ServiceStoreReducer';
import { StoreDependencies } from './StoreDependencies';
import { StoreState } from './StoreState';
import TextReaderEpics from './TextReader/TextReaderEpics';
import { textReaderReducer } from './TextReader/TextReaderReducer';
import { twitchStoreReducer } from './Twitch/TwitchStoreReducer';
import UserStoreEpics from './User/UserStoreEpics';
import { userStoreReducer } from './User/UserStoreReducer';
import UserRunEpics from './UserRun/UserRunEpics';
import { videoStoreReducer } from './Video/VideoStoreReducer';
import VideoAnalysisEnvironmentEpics from './VideoAnalysis/Epics/VideoAnalysisEnvironmentEpics';
import VideoAnalysisEpics from './VideoAnalysis/Epics/VideoAnalysisEpics';
import VideoAnalysisMoonNameEpics from './VideoAnalysis/Epics/VideoAnalysisMoonNameEpics';
import VideoAnalysisMoonTitleEpics from './VideoAnalysis/Epics/VideoAnalysisMoonTitleEpics';
import { videoAnalysisReducer } from './VideoAnalysis/VideoAnalysisReducer';

export function createStore(dependencies: Partial<StoreDependencies>, preloadedState?: StoreState): Store<StoreState> {
  const epicMiddleware: EpicMiddleware<
    AnyAction,
    AnyAction,
    StoreState,
    Partial<StoreDependencies>
  > = createEpicMiddleware({
    dependencies
  });
  const rootEpic = combineEpics<AnyAction, AnyAction, StoreState, Partial<StoreDependencies>>(
    DebugEpics,
    TextReaderEpics,
    AuthPageEpics,
    VideoAnalysisEpics,
    VideoAnalysisMoonTitleEpics,
    VideoAnalysisMoonNameEpics,
    VideoAnalysisEnvironmentEpics,
    UserStoreEpics,
    MediaDeviceMenuEpics,
    SmoLanguageMenuEpics,
    MoonListsEpics,
    MoonListEpics,
    CreateMoonListEpics,
    UserRunEpics,
    WidgetFrontEpics,
    WidgetEpics
  );
  const store: Store<StoreState> = configureStore({
    reducer: {
      debug: debugReducer,
      widget: widgetReducer,
      service: serviceStoreReducer,
      twitch: twitchStoreReducer,
      video: videoStoreReducer,
      user: userStoreReducer,
      textReader: textReaderReducer,
      authPage: authPageReducer,
      moonLists: moonListsReducer,
      moonList: moonListReducer,
      createMoonList: createMoonListReducer,
      videoAnalysis: videoAnalysisReducer,
      mediaDeviceMenu: mediaDeviceMenuReducer
    },
    devTools: IS_DEV,
    middleware: [epicMiddleware],
    preloadedState
  });
  epicMiddleware.run(rootEpic);
  return store;
}
